import type {
  CostCenterEntity,
  CostCenterSourceCoverage,
} from "../api/costCenters";

export function coverageRowToCostCenterEntity(
  row: CostCenterSourceCoverage,
): CostCenterEntity {
  return {
    cost_center_type: row.entity_type,
    cost_center_key: row.entity_key,
    display_label: row.display_label,
    source_display_label: row.source_display_label ?? null,
    manual_display_label: row.manual_display_label ?? null,
    customer_anchor_key: row.customer_anchor_key ?? null,
    customer_anchor_label: row.customer_anchor_label ?? null,
    customer_anchor_reason: row.customer_anchor_reason ?? null,
    project_role: row.project_role ?? null,
    source_observation_count: nullableNumber(row.source_observation_count),
    line_observation_count: nullableNumber(row.line_observation_count),
    document_count: nullableNumber(row.document_count),
    line_count: nullableNumber(row.line_count),
    user_count: nullableNumber(row.user_count),
    first_observed_date: null,
    last_observed_date: row.last_observed_date,
    total_spend: row.total_spend,
    spend_ytd: row.spend_ytd ?? null,
    spend_last_year: row.spend_last_year ?? null,
    spend_last30: row.spend_last30 ?? null,
    source_kinds: null,
    confidence_labels: row.confidence_label,
    has_pdf_evidence: row.has_pdf_evidence,
    has_ugl_evidence: row.has_ugl_evidence,
    has_manual_evidence: row.has_manual_evidence,
  };
}

export function uniqueCostCenterEntities(
  entities: CostCenterEntity[],
): CostCenterEntity[] {
  const seen = new Set<string>();
  const unique: CostCenterEntity[] = [];
  for (const entity of entities) {
    const key = costCenterEntityKey(entity);
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push(entity);
  }
  return unique;
}

function costCenterEntityKey(entity: CostCenterEntity): string {
  return `${entity.cost_center_type}:${entity.cost_center_key}`;
}

function nullableNumber(value: number | string | null | undefined): number | null {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value !== "string" || !value.trim()) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
